import React from 'react';
import PropTypes from 'prop-types';
import { ClickOutside } from '../../layout/ClickOutside';
import Tooltip from '../messages/Tooltip';

class CustomDropDown extends React.Component {
  state = {
    isOpen: false
  };

  toggleOpen = () => {
    this.setState((prevState) => {
      return {
        isOpen: !prevState.isOpen
      };
    });
  };

  toggleAndClick = (clickHandler) => {
    this.toggleOpen();
    clickHandler();
  };

  handleClickOutside = (e) => {
    if (this.state.isOpen) {
      this.toggleOpen();
    }
  };

  render() {
    const { title, items, tooltip } = this.props;
    const { isOpen } = this.state;
    let dropdownCls = 'custom-dropdown';
    if (isOpen) dropdownCls += ' open';

    return (
      <ClickOutside onOutsideClick={this.handleClickOutside}>
        <div className={dropdownCls}>
          {tooltip && <Tooltip id="customDDtip" />}
          <button className="button gray-light custom-dropdown-trigger" onClick={this.toggleOpen} data-for="customDDtip" data-tip={tooltip}>
            {title}
          </button>
          <div className="custom-dropdown-container" style={{ top: '44px' }}>
            {items.map((item) => (
              <div key={item.key}>
                <span className="text-blue cursor-pointer" onClick={() => this.toggleAndClick(item.onClick)}>
                  {item.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </ClickOutside>
    );
  }
}

CustomDropDown.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  tooltip: PropTypes.string
};

export default CustomDropDown;
